import {TargetBlank} from '@wandb/weave/common/util/links';
import {Icon} from '@wandb/weave/components/Icon';
import * as React from 'react';
import {useEffect} from 'react';
import {twMerge} from 'tailwind-merge';

import {WANDB_WORKSPACES_DOCS} from '../Views/utils';
import {useTrackWorkspaceError} from './utils';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {
  WorkspaceError,
  WorkspaceErrorContentProps,
} from './WorkspaceErrorContent';

export const WorkspaceEmptyContent = ({
  error,
  viewType,
}: WorkspaceErrorContentProps) => {
  const trackWorkspaceError = useTrackWorkspaceError({
    action: 'View',
    errorType: 'Empty workspace',
    viewType,
  });

  useEffect(() => {
    trackWorkspaceError(error);
  }, [error, trackWorkspaceError]);

  return (
    <WorkspaceError
      title="No workspace yet"
      header={
        <div
          className={twMerge(
            'mb-16 h-[80px] w-[80px] shrink-0 rounded-full',
            'bg-teal-550/[.1] text-teal-550',
            'flex items-center justify-center'
          )}>
          <Icon name="lightbulb-info" width={34} height={34} />
        </div>
      }>
      <div className="text-wrap mt-4 w-[600px] text-center text-lg leading-[140%]">
        <p>This project doesn't currently have workspaces or saved views. </p>
        <p>Please check back later for updates.</p>
      </div>
      <TargetBlank
        href={WANDB_WORKSPACES_DOCS}
        className="mt-16 font-semibold text-teal-600 hover:text-teal-550">
        Learn more about workspaces
      </TargetBlank>
    </WorkspaceError>
  );
};
